"use client"

import { GlobalErrorView } from "@/components/global-error-view"

import "./globals.css"

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <html lang="en">
      <body>
        <GlobalErrorView digest={error.digest} onRetry={reset} />
      </body>
    </html>
  )
}
